import httpMethod from 'services/update2025/httpMethod';
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import React, { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { SendReceptDataContext } from "./SendReceptDataContext";
export const SendReceptDataHistory = () => {
    const toast = useRef(null);
    const dt = useRef(null);
    const { t, i18n } = useTranslation(["send-recept-data", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const sendReceptDataContext = useContext(SendReceptDataContext);
    const { sendReceptDataHistoryDialog, setSendReceptDataHistoryDialog, sendReceptDataHistories, setSendReceptDataHistories } = sendReceptDataContext;

    const hideDialog = () => {
        setSendReceptDataHistoryDialog(false);
    };

    const statuses = [
        { label: "Thành công", value: "SUCCESS" },
        { label: "Thất bại", value: "ERROR" },
    ];

    const paginatorTemplate = {
        layout: "RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 50, value: 50 },
            ];

            return (
                <React.Fragment>
                    <div style={{ width: "140px", display: "contents" }}>
                        <span className="mx-1">{t("show", { ns: "common" })}: </span>
                        <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                    </div>
                </React.Fragment>
            );
        },
        CurrentPageReport: (options) => {
            return <span style={{ width: "calc(100% - 490px)", textAlign: "center", display: "inline-block" }}>{t("total", { ns: "common", total: options.totalRecords })}</span>;
        },
    };

    const statusTemplateBody = (rowData) => {
        return <div className="flex align-items-left justify-content-left">{statuses.find((e) => e.value === rowData.status)?.label}</div>;
    };

    const syncDateTemplateBody = (rowData) => {
        if (rowData.syncDate) {
            return <div className="flex align-items-left justify-content-left">{rowData.syncDate?.replaceAll("-", "/")}</div>;
        }
        return null;
    };

    return (
        <Dialog visible={sendReceptDataHistoryDialog} style={{ width: "50%" }} header={t("send-receipt-data.history-send-title")} modal className="p-fluid text-center" onHide={hideDialog}>
            <div className="formgrid">
                <div className="grid mt-2">
                    <div className="col-12">
                        <DataTable
                            ref={dt}
                            value={sendReceptDataHistories}
                            dataKey="stt"
                            className="datatable-responsive p-datatable-sm"
                            showGridlines
                            paginator
                            rows={10}
                            first={0}
                            totalRecords={sendReceptDataHistories?.length}
                            paginatorTemplate={paginatorTemplate}
                            paginatorClassName="justify-content-start"
                            emptyMessage="Không có dữ liệu"
                            scrollable
                        >
                            <Column field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} />
                            <Column field="syncDate" className="text-center" style={{ maxWidth: "150px" }} header={t("send-receipt-data.syncDate")} body={syncDateTemplateBody} />
                            <Column field="status" className="text-center" style={{ maxWidth: "100px" }} header={t("send-receipt-data.status")} body={statusTemplateBody} />
                            <Column field="messErro" className="text-center" header={t("send-receipt-data.messErro")} />
                        </DataTable>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </div>
        </Dialog>
    );
};
